import { responsive } from "@huub-web/ui/utils/responsive";
import { rem } from "@huub-web/utils/css/rem";
import { style } from "@vanilla-extract/css";

import { HEADER_BREAKPOINT } from "../../config/layoutConsts";

export const contentMenuPageBreakStyle = style({
  marginTop: rem(-22),
  ...responsive({
    [HEADER_BREAKPOINT]: {
      marginTop: rem(-8),
    },
  }),
});
